import { proNavigator } from "single-spa/react-app/ProNavigator";

const NAV_URL = "digitalsuite_marketresearch_keywordmarketanalysis_total";

export const transformData = (rawData) => {
    const params = proNavigator.getParams();

    return {
        ...rawData,
        records: rawData.Data.map((record) => {
            const { SearchTerm: searchTerm, Favicon: favicon } = record;
            const url = proNavigator.href(NAV_URL, {
                keyword: searchTerm,
                ...params,
            });
            return {
                ...record,
                url,
                favicon,
            };
        }),
    };
};
